<template>
  <div class="w-full">
    <CustomTable>
      <template v-slot:header v-if="faaDocs.length !== 0">
        <th
          class="py-4 px-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          User
        </th>
        <th
          class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Type
        </th>
        <th
          class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Expiry
        </th>
        <th
          class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        ></th>
      </template>
      <template v-slot:body>
        <tr class="text-center" v-if="status.loadingFaaDocs">
          <td colspan="4" class="py-6 text-gray-700">
            <i class="fas fa-circle-notch fa-spin"></i>
          </td>
        </tr>
        <tr
          class="text-center"
          v-if="!status.loadingFaaDocs && faaDocs.length == 0"
        >
          <td colspan="4" class="py-6 text-gray-700">
            No uploaded FAA UAS documents. Uploaded documents will appear here.
          </td>
        </tr>
        <tr v-for="doc in faaDocs">
          <td class="py-4 px-4 border-b border-grey-light">
            {{ doc.owner.name }}
          </td>
          <td class="py-4 px-2 border-b border-grey-light">
            {{ doc.displayType }}
          </td>
          <td class="py-4 px-2 border-b border-grey-light">
            {{ doc.expires_at | displayDate }}
          </td>
          <td class="py-4 pl-2 pr-4 text-right border-b border-grey-light">
            <span
              class="text-blue-600 cursor-pointer"
              v-on:click="toggleReviewFaaDocsModal(doc)"
            >
              <i class="far fa-external-link-square"></i>
            </span>
          </td>
        </tr>
      </template>
    </CustomTable>

    <!-- Modal -->
    <modal id="reviewFaaDoc">
      <span slot="header">Review FAA Document</span>
      <div slot="body" v-if="viewingDoc !== null">
        <p class="mb-4 text-grey-darkest">
          If you upload drone video, you must, <strong>first</strong>, upload
          all relevant supporting documentation including FAA license, FAA
          renewal, and all applicable waivers. Here is where you can upload
          those files individually.
        </p>

        <div class="mb-4">
          <label
            class="block text-grey-darkest font-bold mb-2 focus:outline-none"
          >
            Document
          </label>
          <button
            class="bg-blue-600 text-white px-4 py-2 inline-block rounded mt-4 focus:outline-none"
            v-on:click="openInNewTab()"
          >
            Click to View
          </button>
        </div>

        <div class="mb-4">
          <label class="block text-grey-darkest font-bold mb-2">
            Type
          </label>
          <!-- <label class="dropdown_wrap">
                        <select class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="faaDocModal.type">
                            <option value="part107_initial">FAA Part 107 - Certificate (Card)</option>
                            <option value="part107_recurrent">FAA Part 107 - Recurrent</option>
                            <option value="waiver">Waiver</option>
							<option value="laancreq">Airspace Authorization</option>
                        </select>
                    </label> -->
        </div>

        <div class="mb-4">
          <!-- <label class="block text-grey-darkest font-bold mb-2">
                        {{ faaDocModal.type | displayNumberType }}
                    </label> -->
          <!-- <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" type="text" v-model="faaDocModal.faaRefId"> -->
        </div>

        <div class="flex flex-row mb-4 mx-0 md:-mx-2">
          <div class="mb-4 w-full md:w-1/2 mb-4 md:mb-0 px-0 md:px-2">
            <label class="block text-grey-darkest font-bold mb-2">
              Issued At
            </label>
            <!-- <datetime type="datetime" input-class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="faaDocModal.issuedAt"></datetime> -->
          </div>
          <div class="mb-4 w-full md:w-1/2 px-0 md:px-2">
            <label class="block text-grey-darkest font-bold mb-2">
              Expires At
            </label>
            <!-- <datetime type="datetime" input-class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="faaDocModal.expiresAt"></datetime> -->
          </div>
        </div>

        <!-- <button class="w-full bg-blue-600 text-white px-3 py-3 rounded-lg font-semibold focus:outline-none" v-on:click="submitFaaDoc">
					<i class="fas fa-circle-notch fa-spin" v-if="faaDocModal.submitting"></i>
					<span v-if="!faaDocModal.submitting">Submit Documentation</span>
				</button> -->

        <p class="text-gray-500 text-xs text-center mt-4">
          Please note, it may take up to 24 hours for the document to show as
          approved. Each document is vetted to ensure the document is valid and
          matches the correct user.
        </p>
      </div>
    </modal>
  </div>
</template>

<script>
import { EventBus } from "@/utils/events";
import * as Config from "@/config";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import CustomTable from "@/components/general/CustomTable";
import Modal from "@/components/general/Modal";

export default {
  name: "MailList",
  data() {
    return {
      faaDocs: [],
      status: {
        loadingFaaDocs: true
      },
      date: null,
      viewingDoc: null
    };
  },
  components: {
    CustomTable,
    Datetime,
    Modal
  },
  mounted() {
    this.getLatestPendingDocs();
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    getLatestPendingDocs() {
      this.loading = true;
      var _this = this;

      this.$http
        .get(
          Config.apiPath + "/api/v2/admin/documents/faa",
          this.getAuthorizationHeader()
        )
        .then(response => {
          _this.faaDocs = response.data;
          _this.status.loadingFaaDocs = false;
        });
    },
    toggleReviewFaaDocsModal(doc) {
      this.viewingDoc = doc;
      EventBus.$emit("toggle-modal:reviewFaaDoc");
    },
    openInNewTab() {
      window.open("https://usefulangle.com", "_blank");
    }
  },
  filters: {
    timeAgo: function(date) {
      return moment.utc(date).fromNow();
    },
    displayLocalDateTime: function(date) {
      return moment
        .utc(date)
        .local()
        .format("MMMM Do YYYY, h:mm a");
    }
  }
};
</script>
